import isDev from "../is-dev";

export const baseUri = isDev
  ? "http://localhost:8080/song-learner.massi.world"
  : "https://song-learner.massi.world";
